// index-family-page.component.ts

import { Component, ElementRef } from '@angular/core';

import { AutocompleteResult } from 'SearchApp/ts/interfaces/autocomplete-result.interface';

@Component({ standalone: false, selector: 'ycn-index-family-page', templateUrl: './index-family-page.template.html' })
export class IndexFamilyPageComponent {
    currFamilyName: string;

    constructor(private eltRef: ElementRef) {
        this.currFamilyName = this.eltRef.nativeElement.getAttribute('currFamilyName');
    }

    redirectToIndex(autocompleteResult: AutocompleteResult): void {
        window.location.href = autocompleteResult.url;
    }
}
